import App from '../components/app'
import DivBottom from '../components/divBottom'
import NavbarTopAdmin from '../../admin/components/navbarTopAdmin'
import NavbarBottomAdmin from '../../admin/components/navbarBottomAdmin'
import NavbarNotAuth from '../components/navbarNotAuth'

function Venezia() {
    return (<>
       {localStorage.getItem('logged') && localStorage.getItem('email') !== 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />}
        <div style={{marginTop:'6rem'}}></div>
        <App />
        <div style={{ marginBottom: '50px' }}>
            <div style={{
                textAlign: 'center',
                padding: '3rem 0rem 1rem 0rem'
            }}>
                <h1>Venezia</h1>
                <h5 style={{ color: 'grey', position: 'relative' }}>VENETO
                    <span style={{
                        position: 'absolute',
                        left: '1rem',
                        backgroundColor: 'maroon',
                        color: 'whitesmoke',
                        padding: '3px',
                        borderRadius: '5px'
                    }}>ARTE
                    </span>
                </h5>
            </div>
            <div className='mt-1'>
                <div className='galleria container-fluid'>
                    <div className='gbox1'>
                        <img src={require('../image/venezia-cristina-gottardi-unsplash.jpg')}
                            height='100%' width='100%' alt='' />
                    </div>
                    <div className='gbox2'>
                        <h4>La serenissima</h4><hr />
                        <p className='mt-3'>
                            Grazie alla stabilità politica e alla tranquillità sociale, il 12 maggio 1797 <b>Venezia</b> fu soprannominata la <b>'Serenissima'</b>.
                            La città è famosa per la sua <b>architettura</b> e la sua struttura, caratterizzata da ponti, canali e milioni di pali di legno,
                            piantati nel fondale che la sorreggono dagli albori, per questo sembra quasi che galleggi sopra la laguna.
                            Le infinite viuzze pittoresche, ricche di negozi di ogni genere di artigianato locale, la rendono unica al mondo.<br />
                            Spesso, durante i periodi di forte pioggia, purtroppo Venezia è soggetta ad allagamenti ed inondazioni.
                            Per questo motivo da molti anni, il comune ha adottato misure preventive che rendono comunque percorribile e
                            visitabile la città attraverso passerelle.
                            Se l'alluvione sarà tempestiva e particolarmente violenta, in città suoneranno allarmi per far si che la popolazione
                            si tuteli e metta in atto i protocolli stabiliti.<br />
                            <b>Piazza San Marco</b> sarà la prima ad essere inondata, essendo la parte più bassa della città, ma sarà comunque, una
                            volta messe in atto le misure, consentito percorrerla.
                        </p>
                        <hr /><br />
                    </div>
                    <img src={require('../image/claudio-schwarz-VlI9IQgMilw-unsplash.jpg')}
                        className='galleria_immagine addImg' alt='' />
                    <img src={require('../image/rebe-adelaida-zunQwMy5B6M-unsplash.jpg')}
                        className='galleria_immagine addImg' alt='' />
                </div>

                <p className='m-3'>
                    Durante il <b>Carnevale </b>la città si riempie di turisti desiderosi di sfoggiare i loro meravigliosi abiti di epoca <b>barocca</b>.
                    Nel periodo estivo tra Agosto e Settembre molte star internazionali e locali fanno capolino dalle imbarcazioni per raggiungere il
                    <b> Festival cinematografico di Venezia</b> e percorrere il suo sontuoso tappeto rosso.
                    Chi si aggiudicherà il <b>leone d'oro</b> tra le varie categorie?<br />
                    Venezia è la città romantica per eccellenza ed offre molto ai visitatori,
                    il suo stile inconfondibile renderà la vostra vacanza indimenticabile.
                </p>

                <div className='container mt-2'>

                    <div className='divCittà mt-5'>
                        <h1 className='text-center'>BASILICA DI SAN MARCO</h1>
                        <img src={require('../image/venezia-Victor-he.jpg')} className='imgCittà' alt='' />
                        <p className='mt-3'>
                            Non perderti la maestosa <b>Basilica di San Marco</b>, meta imperdibile della città.
                            Uno dei luoghi più suggestivi del mondo che dovrai visitare almeno una volta nella vita.
                            <br />
                            Ben 8000 metri quadrati di <b>mosaici</b> in smalto, vetro colorato e grandi quantità di oro, compongono esterni ed interni della basilica.
                            Fu realizzata in circa 8 secoli e l'effetto decorativo ottenuto dona al visitatore un'esperienza di forte impatto visivo ed emotivo.
                            Nell'arco della giornata e con il cambiamento della luce ed esposizione solare i mosaici cambieranno tonalità di colore
                            rendendo l'opera ancor più affascinante e suggestiva.
                            Venezia nasce tra il 700 e 800 per poi evolversi a livello architettonico col suo stile inconfondibile, teatro
                            di numerose leggende tramandate nei secoli, come quella relativa al <b>ponte di Rialto</b>. Chissà quale mistero narra?
                        </p>
                    </div>

                    <div className='divCittà mt-5'>
                        <h1 className='text-center'>UN GIRO IN GONDOLA</h1>
                        <img src={require('../image/diego-gennaro-V92cQegtuOs-unsplash.jpg')} className='imgCittà' alt='' />
                        <br />
                        <p className='mt-3'>
                            Scoprire <b>Venezia</b> cullati da questa elegante e romantica imbarcazione sulle acque della laguna è un'esperienza antica e avvolgente
                            in cui potrai scoprire ogni dettaglio della città.
                            Con i loro abiti iconici i <b>gondolieri</b> vi offriranno un indimenticabile esperienza veneziana attraverso canali, cunicoli e ponti
                            fino ad arrivare in mare aperto.<br />
                            La <b>gondola</b> nasce nell'antichità come mezzo di trasporto indispensabile per gli spostamenti all'interno della laguna,
                            mentre oggi viene utilizzata per eventi, cerimonie, tour privati e principalmente come attrazione turistica.
                        </p>
                    </div>

                    <div className='divCittà mt-5'>
                        <h1 className='text-center'>GASTRONOMIA</h1>
                        <img src={require('../image/lukas-krasa-unsplash.jpg')} className='imgCittà' alt='' />
                        <br />
                        <p className='mt-3'>
                            Durante il tour turistico di <b>Venezia</b> potrai fermarti per una breve sosta in uno dei tanti ristoranti
                            della laguna e gustarti i piatti tipici locali.<br />
                            La varietà della cucina tradizionale veneta propone numerosi piatti a base di carne e pesce fino ai gustosi dolci.
                            Di seguito alcune pietanze che potrai gustare nelle trattorie veneziane:<br />
                            <b><i>Sarde in saor, Risi e bisi, Bigoli, Polenta, Baccalà mantecato, Fegato alla veneziana, Fritole, Spumigli (meringa).</i></b><br />
                            Venezia è anche famosa a livello culinario, per i tipici '<b>Cicchetti</b>': aperitivi con
                            degustazione di vini e piccoli assaggi del cibo locale proposti in maniera fantasiosa e gourmet.
                        </p>
                    </div>

                    <div className='divCittà mt-5'>
                        <h1 className='text-center'>COSA FARE A VENEZIA</h1>
                        <img src={require('../image/ricardo-gomez-angel-unsplash.jpg')} alt='' className='imgCittà' />
                        <br />
                        <ul className='mt-3 text-start'>
                            <li>
                                <b>Il Canal Grande</b> è la prima attrazione in cui vi imbatterete ed è il principale canale di Venezia.
                                Lungo 3.8 km e profondo fino a 5mt, il Canal Grande è affiancato da magnifici edifici storici del XVIII secolo.
                            </li>
                            <li>
                                <b>Piazza San Marco</b> e <b>Basilica</b>, famose in tutto il mondo e mete essenziali di ogni turista, viengono visitate da 200000 persone al giorno.
                            </li>
                            <li>
                                <b>Ponte di Rialto</b>, un capolavoro architettonico di maestosità e di grandezza. Percorrerlo è un'esperienza indimenticabile.
                            </li>
                            <li>
                                <b>Vetro soffiato di Murano e di Burano</b>, famoso in tutto il mondo, è un'arte antichissima ed è una delle attrazioni più visitate di Venezia.
                            </li>
                            <li>
                                <b>Il Ponte dei Sospiri</b>, fotografato da tutti i turisti, veniva percorso dai prigionieri per essere giudicati, i quali sospiravano
                                perchè era l'ultimo ponte da dove potevano assaporare la luce del mondo esterno.

                            </li>
                        </ul>
                    </div>

                    <div className='divCittà mt-5'>
                        <h1 className='text-center'>IL CARNEVALE DI VENEZIA</h1>
                        <img src={require('../image/axp-photography -unsplash.jpg')} className='imgCittà' alt='' />
                        <br />
                        <p className='mt-3'>
                            Questo è uno degli eventi italiani più apprezzati e famosi al mondo, cugino del più noto carnevale di Rio.
                            Entrambi conosciuti per la loro peculiarità di trasformismo.<br />
                            Il tutto si svolge durante un'intera settimana dove persone provenienti da ogni luogo, espongono il proprio
                            abito rigorosamente <b>barocco</b>. Il turista verrà quindi catapultato in un altra dimensione storica, dove vigevano
                            sfarzo, eleganza e ricerca dei dettagli nell'abbigliamento.<br />
                            Largo quindi a pompose parrucche, pizzi e tessuti pregiati apoteosi della moda dell'epoca.
                            Ovviamente le maschere più belle parteciperanno ad una premiazione e i loro possessori faranno letteralmente a gara per
                            mostrare le loro meravigliose e particolari opere d'arte, per la gioia dei numerosi turisti che le ammireranno.
                            Si narra, attraverso alcuni scritti, che l'inizio di questa incredibile manifestazione ebbe luogo circa
                            900 anni fa e da allora l'evento non ha mai smesso di stupire l'intero pianeta.
                        </p>
                    </div>

                    <div className='divCittà mt-5'>
                        <h1 className='text-center'>MOSTRA INTERNAZIONALE D'ARTE CINEMATOGRAFICA</h1>
                        <img src={require('../image/venezia-cristina-gottardi-unsplash.jpg')}
                            alt='' className='imgCittà' />
                        <br />
                        <p className='mt-3'>
                            Tra la fine di Agosto e i primi di settembre Venezia diventa uno dei palchi più interessanti della cinematografia mondiale,
                            terza solo come importanza agli'Oscar Hollywoodiani e alla Palma d'oro di Cannes.<br />
                            Numerosi artisti del settore attraversano il famoso <b>red carpet</b> ubicato nel palazzo del cinema al lido di Venezia per assistere in anteprima alle varie proiezioni
                            dei prossimi successi della stagione cinematografica.<br />
                            L'ambito premio <b>Leone d'oro</b> darà lustro, fama e ammirazione alle opere esposte.
                            L'evento, dopo un lungo periodo di crisi, è ritornato ai suoi albori attirando a se i più importanti protagonisti
                            del settore. Numerose star, ogni anno, attirano una folla di fans desiderosi di conoscere i loro beniamini.

                        </p>
                    </div>

                    <div className='divCittà mt-5'>
                        <h1 className='text-center'>LE FONDAMENTA DI VENEZIA</h1>
                        <img src={require('../image/dylan-freedom-unsplash.jpg')} className='imgCittà' alt='' />
                        <br />
                        Sembrerebbe incredibile ma i palazzi in pietra di Venezia sono sorretti da pali di legno immersi nell'acqua!<br />
                        I <b>pali in legno</b> furono piantati nel fondale fangoso della laguna ma, quando il fondale risultava particolarmente instabile,
                        gli antichi costruttori veneziani costruivano una base di legno a immersione.
                        Si immergevano nove pali per metro quadrato, fino a infilarli sotto al fondale melmoso di Venezia,
                        così da creare un robusto appoggio per gli edifici veneziani che venivano costruiti con <b>pietre</b> d'Istria, molto
                        resistenti all'erosione, alla salsedine e agli agenti atmosferici.<br />
                        Tre proprietà della laguna che fanno restare Venezia a galla:
                        <ul className='text-start mt-3'>
                            <li>
                                I pali in legno non marciscono grazie alla mancanza di ossigeno nell'acqua della laguna.
                            </li>
                            <li>
                                La <b>mineralizzazione</b>, che è un processo chimico, induririsce il legno e ne aumenta la resistenza.
                            </li>
                            <li>
                                Il fango presente nell'acqua agisce da cuscinetto ed in parte permette a Venezia di '<b>restare a galla</b>'.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <DivBottom />
        </div >
    </>
    )
}
export default Venezia